// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import Switcher from './controls/Switcher'
import LabeledWrapper from './AudienceEdit/LabeledWrapper'
import PrimaryButton from './controls/PrimaryButton'
import Select from './controls/Select'
import type { OptionType } from './types'

const ElementWrapper: StyledComponent<Object, any, any> = styled.div`
  padding-bottom: 10px;
`
const StyledInput: StyledComponent<Object, any, any> = styled.input`
  width: 100%;
`
const SelectWrapper: StyledComponent<Object, any, any> = styled.div`
  width: 30%;
  line-height: 20px;
`

export type ProviderUtms = {|
  vk: string,
  target_mail: string,
  facebook: string,
  instagram: string,
  google: string
|}

type Props = {|
  utmType: 'ort' | 'provider',
  providerUtms: ProviderUtms,
  ortUtm: string,
  updateType: 'none' | 'active' | 'all',
  isLoading: boolean,
  onInit: Function,
  onChange: Function,
  onApply: Function
|}

const t = {
  apply: 'Применить',
  ort_utms: 'Единые метки',
  provider_utms: 'По сетям',
  vk: 'ВКонтакте',
  target_mail: 'myTarget',
  facebook: 'Facebook',
  instagram: 'Instagram',
  google: 'Google',
  none: 'Не обновлять у уже созданных',
  active: 'Обновлять у созданных: только активных',
  all: 'Обновлять у созданных: всех'
}

export default class ProviderUtmPage extends Component<Props> {
  constructor(props: Props) {
    super(props)

    props.onInit()
  }

  render() {
    const { utmType, ortUtm, isLoading } = this.props
    return (
      <div>
        <ElementWrapper>
          <Switcher
            options={[
              { id: 'ort', name: t.ort_utms },
              { id: 'provider', name: t.provider_utms }
            ]}
            value={utmType}
            onChange={(utmType) => this.props.onChange({ utmType })}
          />
        </ElementWrapper>
        {_.isEqual(utmType, 'ort') && (
          <ElementWrapper className="t-UtmInput__ort">
            <StyledInput
              type="text"
              className="input-item"
              value={ortUtm}
              disabled={isLoading}
              onChange={(e) => this.props.onChange({ ortUtm: e.target.value })}
            />
          </ElementWrapper>
        )}
        {_.isEqual(utmType, 'provider') && (
          <ElementWrapper>
            {this.renderProviderUtmInput('vk')}
            {this.renderProviderUtmInput('target_mail')}
            {this.renderProviderUtmInput('facebook')}
            {this.renderProviderUtmInput('instagram')}
            {this.renderProviderUtmInput('google')}
          </ElementWrapper>
        )}
        <ElementWrapper>
          <SelectWrapper className="t-UtmUpdateTypeSelect">
            <Select
              value={this.props.updateType}
              options={this.updateTypeOptions()}
              disabled={isLoading}
              onChange={(updateType) => this.props.onChange({ updateType })}
            />
          </SelectWrapper>
        </ElementWrapper>
        <ElementWrapper>
          <PrimaryButton height={32} disabled={isLoading} onClick={() => this.props.onApply()}>
            {t.apply}
          </PrimaryButton>
        </ElementWrapper>
      </div>
    )
  }

  renderProviderUtmInput(provider: string) {
    const { providerUtms, isLoading } = this.props
    return (
      <LabeledWrapper className={`t-UtmInput__${provider}`} label={t[provider]} twoLines>
        <StyledInput
          type="text"
          className="input-item"
          value={providerUtms[provider] || ''}
          disabled={isLoading}
          onChange={(e) =>
            this.props.onChange({ providerUtms: { ...providerUtms, [provider]: e.target.value } })
          }
        />
      </LabeledWrapper>
    )
  }

  updateTypeOptions(): Array<OptionType> {
    return [
      { id: 'none', name: t.none },
      { id: 'active', name: t.active },
      { id: 'all', name: t.all }
    ]
  }
}
